<template>
  <div v-if="producto && !loadingFetch">
    <v-row>
      <v-col cols="10">
        <v-toolbar flat color="transparent">
          <v-toolbar-title><h3>Detalles del producto</h3></v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn @click="deshacerCambios" :disabled="!hasChanges" rounded>
            Deshacer cambios
          </v-btn>

          <v-btn
            class="ml-2"
            :light="hasChanges"
            rounded
            @click="validateForm"
            :disabled="!hasChanges"
          >
            Guardar
          </v-btn>

          <v-btn icon>
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row class="mt-2">
      <v-col cols="12" md="6">
        <v-card color="transparent" flat>
          <v-card-text class="pb-0">
            <GenericAttributeInput
              attributeName="descripcion_comercial"
              label="Nombre para la empresa"
              type="text"
              prefix=""
              :rules="'required|max:100'"
              :value="producto.descripcion_comercial"
              :outlined="true"
              @update-attribute="handleAttributeUpdate"
            />
          </v-card-text>
        </v-card>

        <v-card color="transparent" flat>
          <v-card-title>
            <span :style="'font-size: 15px;line-height: 1.5;font-weight: 500;'">
              <b> Precios sugeridos para las sucursales </b>
            </span>
          </v-card-title>

          <v-card-subtitle class="text--secondary mb-6">
            <span
              :style="'font-size: 13px;line-height: 20px;font-weight: 400;'"
            >
              Establece los precios de venta por defecto para las sucursales.
              Podrás ajustarlos individualmente en cada una.
            </span>
          </v-card-subtitle>

          <v-card-text>
            <GenericAttributeInput
              attributeName="precio_costo_base"
              label="Precio de Costo"
              type="string"
              :rules="'required|decimal:2|max:30'"
              :value="producto.precio_costo_base"
              :outlined="true"
              class="mb-4"
              @update-attribute="handleAttributeUpdate"
            />

            <GenericAttributeInput
              attributeName="margen_ganancia_sugerido"
              label="Margen de Ganancia (%)"
              type="string"
              prefix="%"
              :rules="'required|decimal:2|max:30|min_value:0'"
              :value="producto.margen_ganancia_sugerido"
              :outlined="true"
              class="mb-4"
              @update-attribute="handleAttributeUpdate"
            />

            <PrecioVentaCalculatorWrapper
              :precioCosto="producto.precio_costo_base"
              :ganancia="producto.margen_ganancia_sugerido"
              :precioVenta="producto.precio_venta_sugerido"
              :esPrecioVentaManual="false"
              :disabled="true"
              type="string"
              tipoRedondeo="decimales"
              :outlined="true"
              class="mb-4"
              ref="precioVentaWrapper"
            />

            <PrecioVentaCalculatorWrapper
              :precioCosto="producto.precio_costo_base"
              :ganancia="producto.margen_ganancia_sugerido"
              :precioVenta="producto.precio_venta_sugerido"
              :esPrecioVentaManual="true"
              tipoRedondeo="entero"
              :outlined="true"
              @update:precioVenta="
                handleAttributeUpdate({
                  name: 'precio_venta_sugerido',
                  value: $event,
                })
              "
              @update:ganancia="
                handleAttributeUpdate({
                  name: 'margen_ganancia_sugerido',
                  value: $event,
                })
              "
              ref="precioVentaWrapper"
            />
          </v-card-text>
        </v-card>
        <v-card color="transparent" flat>
          <v-card-text>
            <div class="mt-2">
              <b>Origen del producto</b>
            </div>
            <form-producto-es-elaboracion-propia
              :outlined="true"
              :producto="producto"
              @set-elab-prop="
                handleAttributeUpdate({
                  name: 'es_elaboracion_propia',
                  value: $event,
                })
              "
            >
            </form-producto-es-elaboracion-propia>

            <form-producto-proveedor
              @set_proveedor="setProveedor"
              :outlined="true"
              :producto="producto"
            >
            </form-producto-proveedor>
            <form-producto-categoria
              @set_categoria="
                setCategoria({
                  name: 'categoria',
                  value: $event,
                })
              "
              :producto="producto"
              :categoria="producto.categoria"
            >
            </form-producto-categoria>
          </v-card-text>
        </v-card>
        <ProductosGestionHomeSucursales
          @refresh-producto="$emit('refresh-producto')"
          :productoProp="productoProp"
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-card justify="start" class="mb-4">
          <v-container>
            <v-card-title>
              <v-icon left class="mr-2">mdi-link-variant</v-icon>
              Producto de catálogo asociado
            </v-card-title>

            <v-img
              src="require('@/assets/no-image.png')"
              aspect-ratio="1"
              height="250"
              contain
              style="object-fit: contain"
            />

            <v-card-text class="text-left">
              <div class="text-subtitle-2 mb-4">
                Este producto está vinculado al catálogo general. No puede
                modificarse, pero podés consultarlo para más información.
              </div>

              <v-list dense nav>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold"
                      >Descripción</v-list-item-title
                    >
                    <v-list-item-subtitle class="text--primary">
                      {{ productoProp.descripcion_global }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold"
                      >Código de barra</v-list-item-title
                    >
                    <v-list-item-subtitle
                      class="text--primary d-flex align-center"
                    >
                      <v-icon small class="mr-1">mdi-barcode</v-icon>
                      {{ productoProp.codigo_barra || "Sin código definido" }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold"
                      >Marca</v-list-item-title
                    >
                    <v-list-item-subtitle class="text--primary">
                      {{
                        (productoProp.marca && productoProp.marca.nombre) ||
                        "Sin marca definida"
                      }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold"
                      >Categoría</v-list-item-title
                    >
                    <v-list-item-subtitle class="text--primary">
                      {{
                        (productoProp.categoria &&
                          productoProp.categoria.nombre) ||
                        "Sin categoría definida"
                      }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>

            <v-card-actions class="justify-center">
              <v-btn text color="primary" @click="mostrarDetallesCatalogo">
                Ver detalles completos
                <v-icon right>mdi-open-in-new</v-icon>
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { administrarMixin } from "@/mixins/producto/administrarMixin.js";
import LayoutRegistrarProducto from "@/layouts/productos/layout.registrar.producto";
import ProductoVistaPrevia from "@/components/producto/producto.vista.previa.vue";

import FormProductoProveedor from "@/components/producto/form/form.producto.proveedor.vue";
import FormProductoCategoria from "@/components/producto/form/form.producto.categoria.vue";
import FormProductoDescripcion from "@/components/producto/form/form.producto.descripcion.vue";
import FormProductoBarcode from "@/components/producto/form/form.producto.barcode.vue";

import ProductoForm from "@/components/producto/form/producto.form";
import FormProductoMarca from "@/components/producto/form/form.producto.marca.vue";
import FormProductoPrecioCosto from "@/components/producto/form/form.producto.precio.costo.vue";
import FormProductoGanancia from "@/components/producto/form/form.producto.ganancia.vue";
import FormProductoIva from "@/components/producto/form/form.producto.iva.vue";
import FormProductoFlete from "@/components/producto/form/form.producto.flete.vue";
import FormProductoPrecioVenta from "@/components/producto/form/form.producto.precio.venta.vue";
import PrecioVentaCalculatorWrapper from "@/components/producto/form/PrecioVentaCalculatorWrapper.vue";

import FormProductoInventario from "@/components/producto/form/form.producto.inventario.vue";
import FormProductoEsElaboracionPropia from "@/components/producto/form/FormProductoEsElaboracionPropia.vue";

import GenericAttributeInput from "@/components/util/GenericAttributeInput.vue";

import CalculadoraPrecioVenta from "@/components/producto/actualizar/producto.calculadora.precioVenta.vue";
import AlicuotaIvaSelect from "@/components/util/AlicuotaIvaSelect.vue";
import RubroVentaListSelect from "@/components/contabilidad/RubroVentaListSelect.vue";
import RubroCompraListSelect from "@/components/contabilidad/RubroCompraListSelect.vue";

import ProductosGestionHomeSucursales from "@/views/producto/gestion/ProductosGestionHomeSucursales.vue";

import { mapActions, mapMutations } from "vuex";
import ProductosAPI from "@/api/productos";

export default {
  name: "ProductosGestionHomeItemActualizar",
  components: {
    ProductosGestionHomeSucursales,
    GenericAttributeInput,
    FormProductoCategoria,
    FormProductoDescripcion,
    FormProductoBarcode,
    ProductoForm,
    LayoutRegistrarProducto,
    FormProductoProveedor,
    FormProductoMarca,
    FormProductoPrecioCosto,
    FormProductoGanancia,
    FormProductoIva,
    FormProductoFlete,
    FormProductoPrecioVenta,
    PrecioVentaCalculatorWrapper,
    ProductoVistaPrevia,
    FormProductoInventario,
    CalculadoraPrecioVenta,
    FormProductoEsElaboracionPropia,
    AlicuotaIvaSelect,
    RubroVentaListSelect,
    RubroCompraListSelect,
  },
  $_veeValidate: {
    validator: "new",
  },
  props: {
    productoProp: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loadingFetch: false,
      producto: null,
      originalProductoState: null,
    };
  },
  computed: {
    hasChanges() {
      // Si el producto aún no ha cargado o no hay estado original, no hay cambios detectables
      if (!this.producto || !this.originalProductoState) {
        return false;
      }

      // Compara la representación JSON de los dos objetos.
      // Esto es una comparación "profunda" simple. Funciona bien para datos básicos (strings, numbers, booleans, arrays, objetos simples).
      // ¡CUIDADO! No funciona para fechas (se vuelven strings), funciones, undefined, Infinity, objetos con referencias circulares.
      // Si tu objeto producto es complejo, considera una librería como Lodash (_.isEqual) para una comparación profunda robusta.

      return (
        JSON.stringify(this.producto) !==
        JSON.stringify(this.originalProductoState)
      );
    },
  },

  methods: {
    ...mapActions("productos", [
      "actualizar_producto_empresa",
      "fetch_productos_mas_vendidos",
    ]),
    deshacerCambios() {
      console.log("Deshaciendo cambios...");
      // 1. Asegúrate de que haya una copia del estado original para restaurar
      if (this.originalProductoState) {
        // 2. Reemplaza el estado actual 'this.producto' con una COPIA PROFUNDA del estado original.
        //    ¡Es crucial que sea una copia profunda para no terminar editando el original!
        this.producto = JSON.parse(JSON.stringify(this.originalProductoState));
        console.log("Estado actual restablecido a:", this.producto);

        // // 3. Opcional pero recomendado: Disparar una validación inicial en todos los campos
        // //    después de que el DOM se haya actualizado con los valores restablecidos.
        // //    Esto limpia los mensajes de error que pudieran haber aparecido durante la edición
        // //    y asegura que el formulario muestre el estado de validación correcto del estado original.
        // this.$nextTick(() => {
        //   // $nextTick espera a que Vue haya actualizado el DOM
        //   this.validateAllFields(); // Llama al método auxiliar para validar todos los refs
        // });
      } else {
        console.warn("No hay estado original para deshacer cambios.");
        // Podrías mostrar un mensaje al usuario si esto ocurre inesperadamente
      }
    },
    handleAttributeUpdate({ name, value }) {
      console.log(name, value);

      this.$set(this.producto, name, value); // Usar $set es una buena práctica si el atributo pudiera no existir inicialmente
    },

    setCategoria(categoria) {
      this.producto.categoria.id = categoria.id;
    },
    setMarca(marca) {
      this.producto.marca.id = marca.id;
    },
    setProveedor(proveedor) {
      this.producto.proveedor.id = proveedor.id;
    },

    validateForm(nextStep) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.actualizarProducto(this.producto);
        } else {
          this.$validator.validate();
        }
      });
    },
    actualizarProducto(p) {
      this.loading = true;

      this.actualizar_producto_empresa(p)
        .then((response) => {
          // this.update_product(data);
          this.$updateBus.$emit("showSnackBar", {
            show: true,
            button: false,
            color: "success",
            text: "Producto Actualizado",
            icon: "mdi-check",
            timeout: 2000,
          });
          this.loading = false;
          this.$emit("refresh-producto");
        })
        .catch((e) => {
          this.loading = false;
          this.$updateBus.$emit("showSnackBar", {
            show: true,
            button: false,
            color: "info",
            text: "Problema inesperado",
            icon: "mdi-information",
            timeout: 3000,
          });
          this.loading = false;
        });
    },
  },
  watch: {
    /**
     * Watcher que reacciona a los cambios en la prop 'productoProp'.
     * Se ejecuta al montar (immediate: true) y cada vez que el padre cambia la prop.
     * Clona la prop para crear el estado editable local y la copia original.
     */
    productoProp: {
      handler(newVal) {
        console.log("Hola producto prop: ", newVal);

        if (newVal) {
          // Asegurarse de que newVal no es null/undefined
          console.log(
            "Watcher: Prop 'productoProp' recibida o actualizada.",
            newVal
          );
          // ** HAZ LA COPIA PROFUNDA AQUÍ PARA EL ESTADO EDITABLE **
          this.producto = JSON.parse(JSON.stringify(newVal));
          // ** HAZ LA COPIA PROFUNDA AQUÍ PARA EL ESTADO ORIGINAL **
          this.originalProductoState = JSON.parse(JSON.stringify(newVal));
          this.loadingFetch = false; // Los datos ya están cargados (vía prop)
          console.log("Estado local y original inicializados desde prop.");

          // Opcional: Inicializar otras flags o estados basados en el productoProp
          // this.isManualMode = newVal.algunaPropQueIndiqueModoInicial ?? true;
        } else {
          // Manejar el caso donde la prop se vuelve null/undefined (si aplica)
          console.log("Watcher: Prop 'productoProp' es null o undefined.");
          this.producto = null;
          this.originalProductoState = null;
          this.loadingFetch = false; // O mantener en true si null significa error
        }
      },
      immediate: true, // Ejecuta el watcher inmediatamente al montar
      // deep: true // Opcional: Si la prop es reactiva en el padre y cambia internamente sin ser un objeto nuevo
    },
  },
};
</script>

<style scoped>
.v-list {
}
</style>
